import { UPDATE_ORDER } from '../actions/types'

const initialState = {
  order: {},
  order_items: [],
  breakable_bundles: [],
  // unbreakable_order_items: [],
  customer: {
    id: '',
    email: '',
    full_name: '',
    ecpid: '',
    eclid: ''
  },
  // order_deduction_summary: [],
  promotion_orders: []
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_ORDER':
      return action.payload
    case UPDATE_ORDER:
      // Currently we have no response to PATCH /orders, return existing state
      return state
    default:
      return state
  }
}
